import Api from "./Api";

export default {

    addUrl(payload) {
        return Api().post(`/urls/${payload.company_id}`, payload.data);
    },
    editUrl(payload) {
        return Api().put(`/urls/${payload.company_id}/${payload.id}`, payload.data);
    },
    deleteUrl(payload) {
        return Api().delete(`/urls/${payload.company_id}/${payload.id}`);
    },

};